import {getServiceOptionsQuery} from './get-service-options'

export const ServiceOptionsQueries = {
  getServiceOptionsQuery
}